<script src="https://apis.google.com/js/platform.js"></script>

<main class="config-container">

  <app-config-nav></app-config-nav>

  <router-outlet></router-outlet>

</main>
